import { render, staticRenderFns } from "./TalkToWarren.vue?vue&type=template&id=4ad46575&scoped=true"
import script from "./TalkToWarren.vue?vue&type=script&lang=ts"
export * from "./TalkToWarren.vue?vue&type=script&lang=ts"
import style0 from "./TalkToWarren.vue?vue&type=style&index=0&id=4ad46575&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad46575",
  null
  
)

export default component.exports